(function ($) {

//    if (window.TL === undefined) {
//        window.TL = {}
//    }

    if (TL.Signin === undefined) {
        TL.Signin = {};
    }

    //Inlnie Popup
    $(document).on('click', '.js-signin-popup', event => {
        event.preventDefault();

        var source = event.currentTarget.hash;
        $.magnificPopup.open({
            type: 'inline',
            items: {
                src: source
            },
            callbacks: {
                close: function () {
                    console.log('Popup closed');
                    closeWelcomeBackPanel();

                    //Reset sign up only mode (set by openSignupOnlyForm)
                    $('#signin-form-popup').removeClass('signup-only');
                }
            },
            mainClass: 'component-popup mfp-slide-up',
            removalDelay: 200,
            modal: true
        });

        $('.js-signin-popup').addClass('onopen-announce-signup');
    });
        
       
    $(document).on('click', '.js-verification-code-popup', event => {
        event.preventDefault();

        var source = event.currentTarget.hash;
        $.magnificPopup.open({
            type: 'inline',
            items: {
                src: source
            },
            mainClass: 'component-popup mfp-slide-up',
            removalDelay: 200,
            modal: true
        });
                
    });
    
           
    $(document).on('click', '.js-verification-method-popup', event => {
        event.preventDefault();

        var source = event.currentTarget.hash;
        $.magnificPopup.open({
            type: 'inline',
            items: {
                src: source
            },
            mainClass: 'component-popup mfp-slide-up',
            removalDelay: 200,
            modal: true
        });                
    });
    
    
    $(document).on('click', '.js-loyalty-program-info', event => {
        event.preventDefault();

        var source = event.currentTarget.hash;
        $.magnificPopup.open({
            type: 'inline',
            items: {
                src: source
            },
            mainClass: 'component-popup mfp-slide-up',
            removalDelay: 200,
            modal: false
        });                
    });
         
    
    //Inlnie close popup
    $(document).on('click', '.mfp-close', function (e) {
        e.preventDefault();
        $.magnificPopup.close();
    });


    var progress = {

        show() {

            //Sign in Button
            $('#userLoiginButton').prop('disabled', true);
            $('#userLoiginButton').addClass('btn-loading');

            //Sign up Button
            $('#userSignupButton').prop('disabled', true);
            $('#userSignupButton').addClass('btn-loading');
            
            //Verfify code
            $('#userVerificationCodeButton').prop('disabled', true);
            $('#userVerificationCodeButton').addClass('btn-loading');
            
            //Resend verification code
            $('#userResendVerificationEmailButton').prop('disabled', true);
            $('#userResendVerificationEmailButton').addClass('btn-loading');
            
            //Verification method
            $('#userVerificationMethodButton').prop('disabled', true);
            $('#userVerificationMethodButton').addClass('btn-loading');
        },

        hide() {

            setTimeout(function () {

                //Sign in Button
                $('#userLoiginButton').prop('disabled', false);
                $('#userLoiginButton').removeClass('btn-loading');

                //Sign up Button
                $('#userSignupButton').prop('disabled', false);
                $('#userSignupButton').removeClass('btn-loading');
                
                //Verfify code
                $('#userVerificationCodeButton').prop('disabled', false);
                $('#userVerificationCodeButton').removeClass('btn-loading');
                
                //Resend verification code
                $('#userResendVerificationEmailButton').prop('disabled', false);
                $('#userResendVerificationEmailButton').removeClass('btn-loading');
                
                //Verification method
                $('#userVerificationMethodButton').prop('disabled', false);
                $('#userVerificationMethodButton').removeClass('btn-loading');
                
            }, 1000);
        },

        close() {

            setTimeout(function () {

                $('#popup-modal-dismiss').click();
            }, 500);
        },

        submitData(type, id, firstName, lastName, email) {
                     
        },
        
        facebookSubmitData(type, id, firstName, lastName, email) {

            //Submit form
            var announce = $('#social-media-signin-form');
            if (announce) {
                $('#social-media-signin-form input[name="social-media-type"]').val(type);
                $('#social-media-signin-form input[name="social-media-id"]').val(id);
                $('#social-media-signin-form input[name="social-media-firstname"]').val(firstName);
                $('#social-media-signin-form input[name="social-media-lastname"]').val(lastName);
                $('#social-media-signin-form input[name="social-media-email"]').val(email);

                //Call remote command
                submitFacebookSignResponseRemoteCommand();
            }

        }
    }

    if (TL.Signin.Progress === undefined) {
        TL.Signin.Progress = progress;
    }
    
    const DISPLAY_TYPE = {
        TOP_BAR: 2310
    };

    const TIMING = {
        RATE_OFFER_DELAY: 400,
        PROGRESS_CLOSE_DELAY: 400
    };

    /**
     * Helper function for top bar rate offer
     */
    function applyTopBarRateOffer(isCleanupHighlightProduct) {
        window.TL.Announce.topbar.hide('#popup_topbar', 400);
        applyRateOfferFromAnnouncementTopBar(isCleanupHighlightProduct);
    }

    /**
     * Helper function for widget rate offer
     */
    function applyWidgetRateOffer(isCleanupHighlightProduct) {
        applyRateOfferFromAnnouncementWidget(isCleanupHighlightProduct);
    }

    var applyRateOfferCode = function (displayTypeCode, isCleanupHighlightProduct) {

        //Top bar
        var displayTypeCodeNumber = Number(displayTypeCode);

        // Apply rate offer based on display type
        setTimeout(function () {

            if (displayTypeCodeNumber === DISPLAY_TYPE.TOP_BAR) {
                applyTopBarRateOffer(isCleanupHighlightProduct);
            } else {
                applyWidgetRateOffer(isCleanupHighlightProduct);
            }

        }, TIMING.RATE_OFFER_DELAY);
               
               
        // Close progress indicator
        setTimeout(() => {
            TL.Signin.Progress.close();
        }, TIMING.PROGRESS_CLOSE_DELAY);        
    }

    if (TL.Signin.applyRateOfferCode === undefined) {
        TL.Signin.applyRateOfferCode = applyRateOfferCode;
    }


    var logout = function () {
        
        if (TL.Signin.Facebook !== undefined) {
            TL.Signin.Facebook.logout();
        }

        if (TL.Signin.Google !== undefined) {
            TL.Signin.Google.logout();
        }
        
        if (TL.Signin.Hotel !== undefined) {
            TL.Signin.Hotel.logout();
        }
        
        TL.Signin.isUserLogout = 'true';
        
        userSignOutRemoteCommand();        
           
        setTimeout(function () {location.reload();}, 500);        
    }

    if (TL.Signin.Logout === undefined) {
        TL.Signin.Logout = logout;
    }


    TL.Signin.setGuestSignInSuccess = function (firstName) {
        
        //Display user signed in        
        TL.Signin.onSigned(firstName);
    }
    
    
    TL.Signin.onSigned = function (firstName) {
        
    }

})(jQuery);

